import { createFileRoute } from '@tanstack/react-router';
import { LrcEditorPage } from '@/page/LrcEditorPage';

export const Route = createFileRoute('/_app/admin/tracks/$trackId/lyrics')({
  component: LrcEditorRoute,
});

function LrcEditorRoute() {
  const { trackId } = Route.useParams();
  return <LrcEditorPage trackId={trackId} />;
}
